import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {ModalParams} from "../model/modal-params";
import {ModalType} from "../model/modal-type";
import {Melody} from "../model/melody";
import {SubscriberMelody} from "../model/subscriber-melody";
import {Contact} from "../model/contact";
import {Group} from "../model/group";

@Injectable({
  providedIn: 'root'
})
export class ModalsService {
  private readonly showModalSubject = new BehaviorSubject<ModalParams>(new ModalParams(false));

  constructor() { }

  getShowModalsObservable(): Observable<ModalParams> {
    return this.showModalSubject.asObservable();
  }

  hideModal(): void {
    this.showModalSubject.next(new ModalParams(false));
  }

  showLogin(callback?: () => void): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.LOGIN, null, null, null, null, null, callback));
  }

  showLogout(): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.LOGOUT));
  }

  showPurchase(melody: Melody): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.PURCHASE, melody));
  }

  showGift(melody: Melody): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.GIFT, melody));
  }

  showSubscriberMelodySettings(subscriberMelody: SubscriberMelody): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.SUBSCRIBER_MELODY_SETTINGS, null, subscriberMelody));
  }

  showSubscriberMelodyDelete(subscriberMelody: SubscriberMelody): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.SUBSCRIBER_MELODY_DELETE, null, subscriberMelody));
  }

  showActivateSubscription(privetPlus: boolean): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.ACTIVATE_SUBSCRIPTION, null, null, privetPlus));
  }

  showDeactivateSubscription(privetPlus: boolean): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.DEACTIVATE_SUBSCRIPTION, null, null, privetPlus));
  }

  showSubscriptionInfo(privetPlus: boolean): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.SUBSCRIPTION_INFO, null, null, privetPlus));
  }

  showContactInfo(contact: Contact): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.CONTACT_INFO, null, null, null, contact));
  }

  showGroupInfo(group: Group): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.GROUP_INFO, null, null, null, null, group));
  }

  showNewContact(): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.EDIT_CONTACT));
  }

  showNewGroup(): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.EDIT_GROUP));
  }

  showEditContact(contact: Contact): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.EDIT_CONTACT, null, null, null, contact));
  }

  showEditGroup(group: Group): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.EDIT_GROUP, null, null, null, null, group));
  }

  showDeleteContact(contact: Contact): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.DELETE_CONTACT, null, null, null, contact));
  }

  showDeleteGroup(group: Group): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.DELETE_GROUP, null, null, null, null, group));
  }

  showUgcUploaded(): void {
    this.showModalSubject.next(new ModalParams(true, ModalType.UGC_UPLOADED));
  }

  showChooseSubscriptions() : void {
    this.showModalSubject.next(new ModalParams(true, ModalType.CHOOSE_SUBSCRIPTIONS))
  }
}
